









import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import PathUtil from '../../modules/util/PathUtil'
import UidCookie from '../../modules/util/UidSetCookie'
import JsonUtil from '../../modules/util/JsonUtil'
import MypageEquipTopList from '../../components/Membership/Mypage/MypageEquipTopList.vue'
import EquipProductCategory from '../../modules/class/EquipProductCategory'

const JSON_PATH_EQUIP_PRODUCT_CATEGORY_LIST = PathUtil.makePath(
  '/json/equip_product_category/equip_list.json'
)

@Component({
  components: {
    MypageEquipTopList
  }
})
export default class MypageEquipTop extends Vue {
  private readonly vueId = 'vue_mypage_equip_top'

  // --------------------------------------------------------------------------------------------------------------------
  // data
  private uidCookie = new UidCookie()
  private jsonList: EquipProductCategory[] = []
  private productCategoryList: number[] = []
  private showResult = false

  // -------------------------------------------------------------------------------------------------------------------
  // hocks
  private mounted() {
    if (document.getElementById(this.vueId) !== null) {
      this.initEquipList()
    }
  }

  // ------------------------------------------------------------------------------------------------
  // computed

  /**
   * Drupalログイン状態を取得
   */
  get isDrupalLogin(): boolean {
    return drupalSettings.vueComponent.common.isDrupalLogin ?? false
  }

  /**
   * 装置情報をフィルタして返す
   */
  get filterEquipList(): EquipProductCategory[] {
    let list: EquipProductCategory[]

    if (this.showResult === false) {
      // 初期化処理が終了していない場合はlistは空を返す
      list = []
    } else {
      list = this.jsonList
      // Drupalログイン時はフィルタせずすべて表示させる
      if (this.isDrupalLogin === false) {
        const keywords = this.productCategoryList
        // 装置管理情報コンテンツJSON内のお気に入り登録しているもののみを抽出する
        list = this.jsonList.filter((equipProductCategory) =>
          keywords.includes(equipProductCategory.productCategoryId)
        )
      }
      // 表示処理
      this.setVisible(list.length > 0)
    }

    return list
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * init get equip list
   */
  private async initEquipList() {
    // JSON取得
    await this.getJson(JSON_PATH_EQUIP_PRODUCT_CATEGORY_LIST)
    // Drupalログインチェック
    if (this.isDrupalLogin === true) {
      this.showResult = true
    } else {
      // Drupalにログインしていない場合、ユーザ情報を取得する
      this.verifyLoginGetUser()
    }
  }

  /**
   * JSON取得処理。
   */
  private async getJson(path: string) {
    const res = await axios.get(path)
    if (res === undefined || res.status !== 200) {
      return
    }
    this.jsonList = res.data.map((d: Record<string, unknown>) =>
      JsonUtil.jsonToObject<EquipProductCategory>(EquipProductCategory, d)
    )
  }

  /**
   * verifyLogin後にユーザー情報ユーザー情報を取得する
   */
  private verifyLoginGetUser() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginGetUserResponse
    })
  }

  /**
   * verifyLoginコールバック、ログインユーザー情報取得を呼び出す
   */
  private async verifyLoginGetUserResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }
      // Cookieに３点セットをセット
      this.uidCookie.setUid(info)
      const form = JSON.stringify({
        accountInfo: info
      })

      const res = await axios
        .post(PathUtil.makePath('/member/api/login_user'), form)
        .catch((err) => {
          return err.response
        })
      if (res !== undefined && res.status === 200) {
        // お気に入り登録している製品カテゴリを取得
        this.productCategoryList = res.data.product_category
        // 装置管理情報コンテンツJSON内のお気に入り登録しているもののみを抽出する
      }
    }
    this.showResult = true
  }

  /**
   * 表示するコンテンツがある：自由領域上、下を表示
   * 表示するコンテンツがない：興味のある製品なし時のコンテンツを表示
   */
  private setVisible(existsFlag: boolean) {
    if (existsFlag) {
      // 表示するコンテンツがあるとき以下を表示する
      // 自由領域上
      const contentTop: HTMLDivElement = document.getElementById(
        'product_content'
      ) as HTMLDivElement
      if (contentTop !== null) {
        contentTop.style.display = ''
      }
      // 自由領域下
      const contentBottom: HTMLDivElement = document.getElementById(
        'product_content_loq'
      ) as HTMLDivElement
      if (contentBottom !== null) {
        contentBottom.style.display = ''
      }
    } else {
      // 表示するコンテンツがないとき
      // 興味のある製品なし時のコンテンツ
      const noContent: HTMLDivElement = document.getElementById(
        'no_product_content'
      ) as HTMLDivElement
      if (noContent !== null) {
        noContent.style.display = ''
      }
    }
  }
}
